import { Component } from "react";
import ReactToPrint from "react-to-print";
import { useBarcode } from 'next-barcode';
import { translateProductType } from "../../utils/translator";
import logo from '../../assets/images/logo.png'


class Barcodes extends Component {
    render() {
        const { barcodes } = this.props
        function BarcodeRend(roll) {
            const { inputRef } = useBarcode({
                value: roll.roll?.upc,
                options: {
                    format: 'CODE128',
                    width: '2px',
                    height: '45px',
                    fontSize: '16px'
                }
            });
            return <svg ref={inputRef} />;
        }
        return (
            <div>
                {
                    barcodes?.map((roll, index) => (
                        <div className="grid grid-cols-12 justify-center items-center p-2 ms-3 me-5 border" style={{ width: "10cm", height: "165px", marginTop: "1px", marginBottom: "1px" }}>
                            <div className='flex flex-col justify-center align-items-start col-span-6'>
                                <div style={{ fontSize: '10px' }} className="z-50">
                                    <p className='block mb-0 truncate'>ÜRÜN KODU : {roll?.product.collectionCode} </p>
                                    {/* {
                                        roll?.product.type &&
                                        <p className='block mb-0'>ÜRÜN TİPİ: {translateProductType(roll?.product.type)} </p>
                                    } */}
                                    {
                                        roll.product.color &&
                                        <>
                                            <p className='block mb-0'>RENK KODU: {roll?.product.color.code} </p>
                                            <p className='block mb-0'>RENK ADI: {roll?.product.color.name} </p>
                                        </>
                                    }
                                    {
                                        roll.product.weight &&
                                        <>
                                            <p className='block mb-0'>GRAMAJ KODU: {roll?.product.weight.code} </p>
                                            <p className='block mb-0'>GRAMAJ ADI: {roll?.product.weight.name} </p>
                                        </>
                                    }
                                    {
                                        roll.product.pattern &&
                                        <>
                                            <p className='block mb-0'>DESEN KODU: {roll?.product.pattern.code} </p>
                                            <p className='block mb-0'>DESEN ADI: {roll?.product.pattern.name} </p>
                                        </>
                                    }
                                    {
                                        roll.boilerCode &&
                                        <p className='block mb-0'>{roll.boilerCode} </p>
                                    }
                                    <p className='block mb-0'>METRE: {roll?.quantity} m</p>
                                    <p className='block mb-0'>KALAN: {roll?.restQuantity} m</p>
                                    <label className='block' style={{ fontSize: '10px' }}> Tarih : {roll?.date} </label>
                                    <label className='d-block' style={{ fontSize: '8px' }}>  Dikkat! Kontrol etmeden işleme almayınız. </label>
                                </div>

                            </div>
                            <div className='flex flex-col justify-center items-center col-span-5 text-center'>
                                <img className='barcode-logo' src={logo} alt={"barcode"} style={{ filter: 'invert(100%)', width: '75px', marginBottom: '.5rem' }} />
                                <BarcodeRend roll={roll} />
                            </div>
                        </div>
                    ))
                }

            </div>
        )
    }
}

class BarcodePrinter extends Component {
    render() {
        const { barcodes } = this.props
        return (
            <div style={{ width: '100%' }}>
                <ReactToPrint
                    trigger={() => <label className='u-fs-14' style={{ width: '100%', cursor: 'pointer' }} >Yazdır</label>}
                    content={() => this.componentRef}
                    documentTitle={`BARKODLAR`}
                    copyStyles={true}
                />
                <div className='hidden'>
                    <Barcodes
                        barcodes={barcodes}
                        ref={el => this.componentRef = el}
                    />
                </div>

            </div>
        )
    }
}

export default BarcodePrinter